const KEY = "employeePortalSession_v1";
const TTL_MS = 12 * 60 * 60 * 1000;

/**
 * @typedef {{ v: number, docId: string, empCollectionName: string, employeeId: string, displayName: string, branchFilter: string, expiresAt: number }} EmployeePortalSession
 */

/** @returns {EmployeePortalSession | null} */
export function getEmployeePortalSession() {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const o = JSON.parse(raw);
    if (!o || o.v !== 1 || !o.expiresAt || Date.now() > o.expiresAt) {
      sessionStorage.removeItem(KEY);
      return null;
    }
    return o;
  } catch {
    return null;
  }
}

export function setEmployeePortalSession(payload) {
  const row = {
    v: 1,
    docId: String(payload.docId || ""),
    empCollectionName: String(payload.empCollectionName || ""),
    employeeId: String(payload.employeeId || ""),
    displayName: String(payload.displayName || ""),
    branchFilter: String(payload.branchFilter || "Main"),
    expiresAt: Date.now() + TTL_MS,
  };
  sessionStorage.setItem(KEY, JSON.stringify(row));
}

export function clearEmployeePortalSession() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
